import DataGrid, {
    IToolbarProps, Toolbar, Item, Grouping, GroupPanel,
    HeaderFilter, IDataGridOptions, Pager, Paging, Scrolling,
    SearchPanel, ColumnChooser, Sorting
} from 'devextreme-react/data-grid';
import React, { MutableRefObject, PropsWithChildren, useEffect, useState, useRef } from 'react';
import dxDataGrid from "devextreme/ui/data_grid";
import { RenderTemplateClassName, RenderTemplateImage, RenderTemplateLink, RenderTemplateRawText, TemplateImage } from '../utils/TemplateImage';
import { ObjectUtils } from '../utils/ObjectUtils';
import { Template } from 'devextreme-react/core/template';
import { isMobileDevice } from "../utils/DeviceDetect";

export interface IMyDataGridOptions extends IDataGridOptions {
    licenceStore?: any;
    onAfterRowChange?: (value: any) => void;
    innerRef?: any;
    __needRefreshAfterContentReady?: boolean;
}
/*
    // __needRefreshAfterContentReady - это затычка, чтобы сначала отрисовывалась таблицы, а потом данные в ней обновляются
    // если без нее, то при количестве записей (не помещающихся на экран) нижняя часть таблицы получается заблюреной и не прокручивается
    Проблема вскрылась при добавлении "templateLink" 2025.01.31
*/    

const CommonLicenceDataGrid: React.FC<PropsWithChildren<IMyDataGridOptions>> = ({ licenceStore, ...props }) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [allGroupExpanded, setAllGroupExpanded] = useState(false);
    const allowedPageSizes = [5, 10, 20];
    let refreshed = false;

    const onFocusedRowChanged = (e) => {
        if (props.onAfterRowChange) {
            if (e && e.row) {
                props.onAfterRowChange(e.row.data);
            }
        }
    }
    const onRowPrepared = (e) => {
        if (e && e.rowType == "data" && e.rowElement && e.data && e.data.ClassName) {
            if (e.rowElement.classList) {
                e.rowElement.classList.add(e.data.ClassName);
            }
        }
    }

    const onContentReady = (e) => {
        if (!refreshed && props.__needRefreshAfterContentReady) {
            refreshed = true;
            refreshDataGrid();
        }
        if (e && e.component) {
            if (props.onAfterRowChange) {
                props.onAfterRowChange(e.component.getTopVisibleRowData());
            }
        }
    }
    const collapseAllClick = () => {
        setAllGroupExpanded(!allGroupExpanded);
    }
    let dataGridRef = props.innerRef || useRef(null);

    const dataGridInstance = (): dxDataGrid => {
        let dataGrid = dataGridRef.current;
        if (dataGrid) {
            let instance: dxDataGrid | null = dataGrid.instance;
            if (instance) {
                return instance;
            }
        }
        return null;
    }



    const refreshDataGrid = () => {
        if (dataGridInstance()) {
            dataGridInstance().refresh();
        }
    }
    const commonToolbar = (): IToolbarProps => {
        return {
            items: [
                {
                    name: "groupPanel",
                    visible: true,
                },
                {
                    location: "after",
                    widget: "dxButton",
                    visible: false,
                    options: {
                        icon: 'refresh',
                        onClick: refreshDataGrid
                    }
                },
                {
                    location: "after",
                    widget: "dxButton",
                    visible: true,
                    options: {
                        text: allGroupExpanded ? 'Свернуть все' : 'Раскрыть все',
                        onClick: collapseAllClick
                    }
                },
                {
                    location: "after",
                    name: "exportButton",
                    visible: false,
                },
                {
                    location: "after",
                    name: "searchPanel",
                },
//                {location: "after",name: "columnChooserButton",},
            ]
        }
    }

    const getToolbar = (): IToolbarProps => {
        let res = commonToolbar();
        const hidden = (props && props["toolbar"] && props["toolbar"]["visible"] == false);
        const disabled = (props && props["toolbar"] && props["toolbar"]["disabled"] == true);
        if (hidden) {
            res.visible = false;
        }
        res.disabled = disabled;
//        if (props && props["toolbar"]) {
//            Object.assign(res, props["toolbar"]);
//        }
//        return res;
        const resItems = ((props && props["toolbar"] && props["toolbar"]["items"]) || []).concat(res.items);
        res.items = resItems;
        return res;
    }


    ObjectUtils.evalAllProperty(props, props, false, 1, 4);

    return (
        <div style={{ height: "100%" }}>
            <DataGrid
                ref={dataGridRef}
                dataSource={licenceStore}
                keyExpr="Id"
                showRowLines={true}
                showBorders={true}
                columnAutoWidth={true}
                wordWrapEnabled={true}
                autoNavigateToFocusedRow={true}
                focusedRowEnabled={true}
                selectedRowKeys={selectedRowKeys}
                onFocusedRowChanged={onFocusedRowChanged}
                onContentReady={onContentReady}
                onRowPrepared={onRowPrepared}
                //            style={{ height: "100%", width: "100%" }}
                className="common-licence-data-grid"
                {...props}
                //                defaultColumns={getDefaultColumns()}
                //                columns={props["defaultColumns"]}
                toolbar={getToolbar()}
                allowColumnReordering={isMobileDevice ? false : true}
                allowColumnResizing={isMobileDevice ? false : true}
            >
                <Scrolling mode="virtual" />
                <Paging
                    enabled={false}
                    defaultPageSize={10}
                />
                <Pager
                    visible={false}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showInfo={true}
                />
                <SearchPanel visible={true}                 

                />
                <HeaderFilter visible={false} />
                <Grouping
                    autoExpandAll={allGroupExpanded}
                    allowCollapsing={true}
                />
                <GroupPanel
                    visible={true}
                />
                <ColumnChooser
                    enabled={false}
                    mode="select"
                    height="100%"
                />
               <Sorting mode="multiple" />
                {props.children}

                <Template name="templateImage" render={RenderTemplateImage} />
                <Template name="templateRawText" render={RenderTemplateRawText} />
                <Template name="templateClassName" render={RenderTemplateClassName} />                
                <Template name="templateLink" render={RenderTemplateLink} />
            </DataGrid>
        </div>
    );
}


export default React.memo(CommonLicenceDataGrid);
